import type { CatalogSort, Offered } from '@/entities/catalog';

/** The orders the workspace offers; the stored one is the default. */
export const WORKSPACE_SORTS: readonly CatalogSort[] = ['manual', 'name', 'opened'];

/** What a workspace section lets the viewer filter by (the section already is the type). */
export const WORKSPACE_OFFERED: Offered = {
  type: false,
  favorites: true,
  recent: true,
  owner: true,
  space: false,
};
